<div id="mosquito-location-draw" #parent>
  <icc-draw [details]="drawService.details" [options]="drawOptions"
    fitTo="width" iccDrawResize
    [drawWidth]="width$ | async" [drawHeight]="height$ | async"
  [parentElement]="parent"></icc-draw>
</div>

<mat-card appearance="outlined">
  <h4>{{ 'MOSQUITO|Wybrane siatki:' | translate }}</h4>

  @if (mosquito$ | async) {
    <div>
      <b>{{ 'MOSQUITO|Siatka do konstrukcji' | translate }}:</b>
      <br>
        <ng-container *ngTemplateOutlet="mosquitoItem;context:{mosquito: (mosquito$ | async)}"></ng-container>
        <br>
        </div>
      }

      @for (sash of (sashes$ | async); track sash) {
        @if (sash.mosquito) {
          <div class="icc-list">
            <h4>{{ 'MOSQUITO|Siatka do kwatery' | translate }} {{sash.index}}:</h4>
            <ng-container *ngTemplateOutlet="mosquitoItem;context:{mosquito: sash.mosquito, sash: sash}"></ng-container>
          </div>
        }
      }
    </mat-card>

    <ng-template #mosquitoItem let-item="mosquito" let-sash="sash">
      <div class="item-imgTitleDescription">
        <p>{{ 'MOSQUITO|Linia' | translate }}: {{item.System.name}}</p>
        <p>{{ 'MOSQUITO|Wymiary' | translate }}: {{ (item.Width |unitmm:1:0) + 'x' + (item.Height |unitmm:1:0)}}</p>
      </div>
    </ng-template>
